interface EtatConnexionSessionProps {
  identiteConfirmee: boolean;
  horsLigne: boolean;
  verificationEnCours: boolean;
  reessayer: () => void;
}

/** Aucun message de succès/synchronisation : seul auth.me est relu ici. */
export function EtatConnexionSession({
  identiteConfirmee,
  horsLigne,
  verificationEnCours,
  reessayer,
}: EtatConnexionSessionProps) {
  return (
    <section
      role="status"
      aria-live="polite"
      className="relative z-10 shrink-0 border-b border-champagne-600/30 bg-champagne-100 px-4 py-3 text-sm text-aubergine-900"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3">
        <div className="min-w-0 flex-1 basis-56">
          <p className="font-semibold">
            {horsLigne ? "Mode hors ligne" : "Connexion au serveur à vérifier"}
          </p>
          <p className="mt-1">
            {identiteConfirmee
              ? "Votre session n’a pas pu être revalidée. La saisie en cours reste affichée ; son enregistrement n’est pas confirmé."
              : "Impossible de vérifier votre session. Vos données ne seront affichées qu’après confirmation de votre identité."}
          </p>
        </div>
        <button
          type="button"
          onClick={reessayer}
          disabled={verificationEnCours}
          className="ui-btn-outline min-h-11 shrink-0 rounded-lg px-4 py-2 disabled:opacity-60"
        >
          {verificationEnCours ? "Vérification…" : "Réessayer"}
        </button>
      </div>
    </section>
  );
}
